import React from "react";

import "./saletag.scss";

const SaleTag = () => {
  return <div className="sale-tag">SALE</div>;
};

export default SaleTag;
